import React from "react";
import Request from "./Request";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

const RequestLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Request" />
      <Request />
    </MasterLayout>
  );
};

export default RequestLayout;
